import { CPA_PREVIEW_HREF } from './cpaPortal';
import { contractorPortalPreviewHref } from './contractorPortalPreview';
import { staffPortalPreviewHref } from './staffPortalPreview';
import { tradePortalPreviewHref } from './tradePortalPreview';
import { buildSupplierPortalPreviewSearch } from './vendorPortalPreviewQuery';

export type AdminPortalPreviewResolution =
  | { type: 'navigate'; href: string }
  | { type: 'cpa'; href: string; enableCpaPreviewFlag: true };

export function resolveAdminPortalPreview(value: string): AdminPortalPreviewResolution | null {
  const raw = value.trim();
  if (!raw) return null;

  if (raw === 'cpa') {
    return { type: 'cpa', href: CPA_PREVIEW_HREF, enableCpaPreviewFlag: true };
  }

  const colon = raw.indexOf(':');
  if (colon <= 0) return null;
  const kind = raw.slice(0, colon);
  const rest = raw.slice(colon + 1);

  if (kind === 'designer' || kind === 'architect' || kind === 'engineer') {
    const uid = rest.trim();
    if (!uid) return null;
    return {
      type: 'navigate',
      href: staffPortalPreviewHref(kind, uid),
    };
  }

  if (kind === 'trade') {
    const uid = rest.trim();
    if (!uid) return null;
    return { type: 'navigate', href: tradePortalPreviewHref({ uid }) };
  }

  if (kind === 'contractor1099') {
    const uid = rest.trim();
    if (!uid) return null;
    return { type: 'navigate', href: contractorPortalPreviewHref(uid) };
  }

  if (kind === 'supplier') {
    const sep = rest.indexOf('::');
    if (sep <= 0) return null;
    const orgId = rest.slice(0, sep).trim();
    const roleRaw = rest.slice(sep + 2);
    if (!orgId) return null;
    const role = roleRaw === 'employee' ? 'employee' : 'owner';
    return {
      type: 'navigate',
      href: `/vendor-portal${buildSupplierPortalPreviewSearch({ orgId, role })}`,
    };
  }

  return null;
}

export function adminPortalPreviewOptionValue(
  kind: 'designer' | 'architect' | 'engineer' | 'trade' | 'contractor1099',
  id: string,
): string {
  return `${kind}:${id.trim()}`;
}

export function adminPortalSupplierPreviewOptionValue(
  orgId: string,
  role: 'owner' | 'employee',
): string {
  return `supplier:${orgId.trim()}::${role}`;
}
